import type { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import { IntelligenceCore } from '@/components/ui/IntelligenceCore';
import { Icon } from '@/components/ui/Icon';
import { routes } from '@/lib/routes';

/**
 * Bottom home block: human Q&A | Research Core circle | human Support.
 * Entry-only Links — never expands rail modules on the public home scroll.
 */
export const HomeSupportBand = () => (
  <section className="home-support-band" aria-label="Q&A, Research Core и поддержка">
    <Link
      to={routes.portalSection('instructions')}
      className="home-support-card home-support-card--side"
      style={{ '--a': '#41d2ff' } as CSSProperties}
    >
      <span className="home-support-ico" aria-hidden="true">
        <Icon name="info" size={20} />
      </span>
      <div className="home-support-copy">
        <strong>Вопрос–ответ</strong>
        <small>Официальная база и ваши вопросы · human review</small>
      </div>
      <em className="home-support-arrow" aria-hidden="true">
        →
      </em>
    </Link>

    <Link to={routes.assistant} className="home-support-core" aria-label="Открыть Research Core">
      <IntelligenceCore
        size="small"
        showWords
        caption={{ title: 'Research Core', subtitle: 'научные сервисы платформы' }}
      />
    </Link>

    <Link
      to={routes.portalSection('contacts')}
      className="home-support-card home-support-card--side"
      style={{ '--a': '#9e80ff' } as CSSProperties}
    >
      <span className="home-support-ico" aria-hidden="true">
        <Icon name="chat" size={20} />
      </span>
      <div className="home-support-copy">
        <strong>Служба поддержки</strong>
        <small>Личный ticket · ответ · история · human support</small>
      </div>
      <em className="home-support-arrow" aria-hidden="true">
        →
      </em>
    </Link>
  </section>
);
